module.exports = __webpack_public_path__ + "images/emoji/japanese_goblin.9750df1eecc9c37c61a3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/japanese_goblin.png
// module id = GM75
// module chunks = 1